import * as Sentry from "@sentry/react";

export interface LogContext {
  [key: string]: any;
}

class SentryLogger {
  debug(message: string, extra?: LogContext) {
    console.debug(message, extra || {});
    Sentry.addBreadcrumb({
      message,
      level: 'debug',
      data: extra,
    });
  }

  info(message: string, extra?: LogContext) {
    console.info(message, extra || {});
    Sentry.addBreadcrumb({
      message,
      level: 'info',
      data: extra,
    });
  }

  warn(message: string, extra?: LogContext) {
    console.warn(message, extra || {});
    Sentry.addBreadcrumb({
      message,
      level: 'warning',
      data: extra,
    });
  }

  error(message: string, error?: Error | unknown, extra?: LogContext) {
    console.error(message, error, extra || {});
    
    // Create context with extra data
    const context = { ...extra };
    
    // If we have an error object, capture it properly
    if (error instanceof Error) {
      Sentry.logger.error(message, { error: String(error),
        tags: { component: 'logger' },
        extra: { message, ...context },
      });
    } else if (error) {
      // If it's not an Error object, capture it as a message with context
      Sentry.logger.error(message, {
        level: 'error',
        tags: { component: 'logger' },
        extra: { error, ...context },
      });
    } else {
      // No error object, just capture the message
      Sentry.logger.error(message, {
        level: 'error',
        tags: { component: 'logger' },
        extra: context,
      });
    }
    
    // Always add breadcrumb for error
    Sentry.addBreadcrumb({
      message,
      level: 'error',
      data: { error: error?.toString(), ...context },
    });
  }
}

export const sentryLogger = new SentryLogger();